<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <IndoorOrOutdoorFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import IndoorOrOutdoorFormPart from 'chimera/painting/components/form/parts/indoorOrOutdoor/IndoorOrOutdoorFormPart'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { PD_10118_REMOVE_PAINTING_QUESTIONS } from 'chimera/all/constants/experiments'
import DefaultNextStep from '~/pages/offertes-aanvragen/type-schilderwerk'
import VariantNextStep from '~/pages/offertes-aanvragen/je-gegevens'

export default {
  name: 'IndoorOrOutdoorFormStep',

  components: {
    IndoorOrOutdoorFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition to next step based on experiment variant.
     */
    async transition() {
      const { getExperiment, isVariant } = useExperiments(this.$store)
      const experiment = await getExperiment(PD_10118_REMOVE_PAINTING_QUESTIONS)
      this.routeTo(isVariant(experiment, 1) ? VariantNextStep : DefaultNextStep)
    },
  },
}
</script>
